import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=bd0e6a98&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=bd0e6a98&prod&scoped=true&lang=less"
import style1 from "./Index.vue?vue&type=style&index=1&id=bd0e6a98&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0e6a98",
  null
  
)

export default component.exports